// AllTreatments.js
import React, { useEffect, useState, useContext } from "react";
import { Container, Row } from "react-bootstrap";
import "../../../assets/css/customer/screens/treatments/Cards.css";
import AppContext from "../../../context/AppContext";
import axios from "axios";
import EsTreatmentCard from "../../../components/customer/Treatments/EsTreatmentCard";

const AllTreatments = ({ screen, activeFilter }) => {
  const { baseUrl } = useContext(AppContext);
  const [treatments, setTreatments] = useState([]);

  useEffect(() => {
    axios
      .post(`${baseUrl}/customer/treatment/viewAllTreatments`)
      .then((response) => {
        console.log("API Treatments:", response.data.treatments);

        const data = response.data.treatments || [];

        if (screen === "home") {
          setTreatments(data.slice(0, 3));
        } else {
          setTreatments(data);
        }
      })
      .catch((error) => {
        console.log("Treatment Error:", error);
      });
  }, [baseUrl, screen]);

  return (
    <section className="estatica-cards">
      <Container>
        <br />

        <div className="ac-treat__header-left">
          <span className="ac-treat__label">FEATURED</span>
          <h2 className="ac-treat__heading">Skin & laser treatments</h2>
        </div>

        <br />
        <br />

        <Row>
          {treatments.length > 0 ? (
            treatments.map((treatment) => (
              <EsTreatmentCard
                key={treatment.id}
                treatment={treatment}
                screenName="customer"
              />
            ))
          ) : (
            <p>No treatments available.</p>
          )}
        </Row>
      </Container>
    </section>
  );
};

export default AllTreatments;